import { createI18n } from 'vue-i18n'

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */

export const localesMap = {
  'en': 'EN',
  'fr': 'FR',
  'es': 'ES',
  'pt': 'PT',
  'de': 'DE',
  'zh': '简体',
  'zt': '繁體',
  'ko': '한국어'
};

const supportedLanguages = Object.keys(localesMap)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key).default
    }
  })
  return messages
}

function detectLanguage() {
  const urlParams = new URLSearchParams(window.location.search);

  const queryLocale = urlParams.get('locale')
  if (queryLocale) {
    return supportedLanguages.includes(queryLocale) ? queryLocale : 'en';
  }

  return Object.keys(supportedLanguages).includes(navigator.language.slice(0, 2)) ? navigator.language.slice(0, 2) : 'en';
}

export default createI18n({
  legacy: false,
  locale: detectLanguage() || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
